/**
 * Created by Languagenut on 09/10/2019.
 */

import Base   from '../../classes/assignments.js';
import UserService from '../../../services/user-service.js';
import ProductService from '../../../services/product-service.js';
import AssignmentStore from '../../../store/assignment-store.js';

import UserStore from '../../../store/user-store.js';
import Constants from '../../../constants.js';
import ClassesService from '../../../services/classes-service.js';

export default class AssignmentManagement extends Base {

    constructor(props) {
        super(props);
        this.state = {
            tab:"active",
            toggle:false,
            assignments:UserStore.assignments || [],
            archivedLanguages:UserStore.archivedLanguages || [],
            archived:UserStore.archived || [],
        };
    }

    componentWillMount(){
        ProductService.getAllLanguages();
        AssignmentStore.on(Constants.GET_ASSIGNMENT_LIBRARY , ()=> {
            var x = AssignmentStore.assignmentLibrary;
            this.setState({
                library:AssignmentStore.assignmentLibrary|| [],
                gotLibrary:true
            })
        })

        UserStore.on(Constants.GET_MY_ASSIGNMENTS , ()=>{

            var fav = [];

            var assignments = UserStore.assignments || []
            for(var i = 0 ; i < assignments.length; i ++)
            {
                UserStore.assignments[i].estimated_time =  UserStore.assignments[i].tasks.length *180
            }

            var assignmentsArchive = UserStore.archived || []
            for(var i = 0 ; i < assignmentsArchive.length; i ++)
            {
                UserStore.archived[i].estimated_time =  UserStore.archived[i].tasks.length *180
            }

            this.setState({
                assignments:UserStore.assignments || [],
                archived:UserStore.archived || [],
                archivedLanguages:UserStore.archivedLanguages || [],
                hasLoaded:true,
            })
        })

        UserStore.on(Constants.GET_ALL_FAV , ()=>{
            function compare(a, b) {
                const aa = a.name.toUpperCase();
                const bb = b.name.toUpperCase();

                let comparison = 0;
                if (aa > bb) {
                    comparison = 1;
                } else if (aa < bb) {
                    comparison = -1;
                }
                return comparison;
            }
              
            var favs = UserStore.favs.slice(0).sort(compare);
            this.setState({
                favs:favs || [],
            })
        })

    }

    createAssignment(){
        window.location.hash =  'assignments/create';
    }

    updateFav(toggle , uid){

        ClassesService.updateFav(toggle == "1" ? "0" : "1" , uid).then(function(){
            UserService.getFavAssignments();
        }.bind(this))
    }

    updateFavLibrary(toggle , row){

        ClassesService.updateFavLibrary((toggle == "1" || toggle == true) ? "1" : "0" , row.homework_uid, row.curriculum_uid).then(function(){
            UserService.getFavAssignments();
        }.bind(this))
    }

    componentDidMount(){
        UserService.getAssignments();
        UserService.getFavAssignments();
    }
}